import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form, Input } from 'antd'
import { useEffect } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedSeatingArea } from '../../../store/SeatingAreaReducer'
import { requiredRule } from '../../../utils/rules'
import { Localizable } from '../../localizable/Localizable'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedSeatingArea())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Localizable.Input name="name" rules={[requiredRule()]} label={'Name'} />
    </Form>
  )
}

export default Update
